function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileInterfaceCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "226.43 226.416 47.14 47.168",
    width: "47.14px",
    height: "47.168px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-75",
    transform: "matrix(1, 0, 0, 1, -0.013161000991779304, 95.11867664931229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.91,160.49a23.67,23.67,0,0,1-18.78,17.62l-.18,0h-.09a23.11,23.11,0,0,1-9.45-.36,19.9,19.9,0,0,1-2.95-.95,3,3,0,0,1-.49-.21,2.91,2.91,0,0,1-.43-.19,16.14,16.14,0,0,1-2.93-1.49,23.57,23.57,0,1,1,35.3-14.45Z",
    style: {
      fill: "#65C7E8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.71,167.11l-.09.33c0,.09-.06.25-.09.37s-.12.52-.21.82c-.09.46-.22,1-.31,1.56a4.63,4.63,0,0,0-.12.7c-.06.42-.15.85-.21,1.31a12.47,12.47,0,0,0-.12,1.52,11,11,0,0,0-.07,1.5,3.25,3.25,0,0,0,.1.85v.15c.06.43.18,1.1.27,1.92a23.11,23.11,0,0,1-9.45-.36,19.9,19.9,0,0,1-2.95-.95,3,3,0,0,1-.49-.21,2.91,2.91,0,0,1-.43-.19c0-1,.37-3.26.58-6,.12-1.37.21-2.86.27-4.33,0-.33,0-.61,0-.94V164c0-.09.07-.12.16-.12a1.93,1.93,0,0,1,.79.24,5.36,5.36,0,0,1,.52.24l.82.19,1.92.45,8.57,2,.27.06Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.58,176.08s0,.09,0,.14a8.24,8.24,0,0,1-1.36.09c-8.92-.13-10.13-11.47-10.13-11.47l3.53.13,9.06,2.12a33.69,33.69,0,0,0-1.22,8.12A4.72,4.72,0,0,0,253.58,176.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.09,149.92c-1.15,4.78,2.15,18.18,5.67,21,5.09,4.09,13,4,16.41-2,3.26-5.85-1.34-23.24-5.23-25.76C250.21,139.44,240.79,142.87,239.09,149.92Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,158.53s-.06.06-.05.1c.25.89.38,2-.37,2.46,0,0,0,.06,0,0C252.59,160.76,252.4,159.34,252,158.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,157.78c-1.48.24-.9,3.18.48,3S252.23,157.58,251,157.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.49,157.23s.08,0,.09.06c.15.92.48,2,1.36,2.08,0,0,0,0,0,.06C257.91,159.49,257.49,158.12,257.49,157.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.11,156.11c1.45-.4,2.15,2.52.81,2.89S256.9,156.45,258.11,156.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.56,156.67a11.37,11.37,0,0,0,1.06-.63c.4-.25.75-.4.95-.85a.61.61,0,0,0-.25-.73,1.56,1.56,0,0,0-1.58.15,2.32,2.32,0,0,0-1.11,1.24A.68.68,0,0,0,249.56,156.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,154.41c-.42,0-.82,0-1.23-.07a2,2,0,0,1-1.24-.32.62.62,0,0,1-.12-.76,1.58,1.58,0,0,1,1.48-.6,2.35,2.35,0,0,1,1.56.59A.68.68,0,0,1,259,154.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.78,166.78c.26.17.54.42.87.38a2.35,2.35,0,0,0,.94-.42s.06,0,0,0a1.26,1.26,0,0,1-1.06.72,1,1,0,0,1-.88-.66C252.68,166.79,252.74,166.76,252.78,166.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.19,163.86a3.2,3.2,0,0,0,2.35,1,4,4,0,0,0,1.13-.17l.21-.07.19-.07a.24.24,0,0,0,.14-.24h0a.32.32,0,0,0,0-.09h0l0-.08c-.12-.7-.4-1.75-.4-1.75.28.07,1.71.4,1.61,0a47.33,47.33,0,0,0-3.07-9.15c-.05-.1-.2,0-.17.05.65,2.91,1.8,5.69,2.49,8.61a5.42,5.42,0,0,0-1.56-.15c-.09,0,.58,2,.61,2.34a0,0,0,0,1,0,0,4.39,4.39,0,0,1-3.41-.36C253.18,163.72,253.12,163.8,253.19,163.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.18,164.38a3.7,3.7,0,0,1-1.24,1.44,1.62,1.62,0,0,1-1,.26c-.76,0-.91-.71-.9-1.3a4,4,0,0,1,.16-.94A4.83,4.83,0,0,0,256.18,164.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.94,165.82a1.62,1.62,0,0,1-1,.26c-.76,0-.91-.71-.9-1.3A1.74,1.74,0,0,1,254.94,165.82Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,161.6s-4.79-7.56-4.45-12c.15-2,2.85-3.41,2.85-3.41a4.52,4.52,0,0,1,1.33-4.58c2.32-2.27,8.06-1.89,8.06-1.89s3.6-5.45,8.9-3.43,2,8,2,8,2,2.7-2.68,4.94-14,.33-14,.33a32.58,32.58,0,0,1,.06,9.71A3,3,0,0,1,240.37,161.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.06,139.78a9.16,9.16,0,0,0-3.71-.6,9.87,9.87,0,0,0-3.31.59,5.51,5.51,0,0,0-3.8,4.23,3.84,3.84,0,0,0,.79,2.89s.08,0,.05,0c-1.25-1.47-.66-3.83.57-5.11a8.35,8.35,0,0,1,5.5-2.17,16.29,16.29,0,0,1,3.88.33A.06.06,0,1,0,249.06,139.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.87,138.76a4.53,4.53,0,0,0-3.18-2.81,7.71,7.71,0,0,0-5,.28,9.74,9.74,0,0,0-4,3.1s0,.07.05,0a8.51,8.51,0,0,1,8.06-3.19,4.66,4.66,0,0,1,3.41,2.23,4.59,4.59,0,0,1,0,3.9,8.67,8.67,0,0,1-3.31,3.46s0,.07,0,0a9,9,0,0,0,3.31-2.94A5,5,0,0,0,260.87,138.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,149.5a16,16,0,0,1-6.58,1.29,32.78,32.78,0,0,1-7-.81c-1.33-.29-2.65-.63-4-1,0,0-.06.05,0,.06a35.15,35.15,0,0,0,7.17,2.05,17.61,17.61,0,0,0,6.86-.21,15.22,15.22,0,0,0,3.55-1.33S257.55,149.49,257.52,149.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.65,160.79s-3.41-4.13-5.3-2.88.91,7.41,3.31,8.09a2.37,2.37,0,0,0,3.07-1.53Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.2,159.66s0,.05,0,.06a6,6,0,0,1,3.4,3.5,1.32,1.32,0,0,0-2-.2s0,.1.05.08a1.48,1.48,0,0,1,1.65.38,7.67,7.67,0,0,1,.87,1.24c.09.14.34,0,.28-.12l0,0C242.3,162.47,240.45,159.69,238.2,159.66Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInterfaceCuate);
export default __webpack_public_path__ + "static/media/Profile Interface-cuate.99b4af89400c5b67fe1652ce3b272875.svg";
export { ForwardRef as ReactComponent };